var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 74,
    viewBox: "0 0 58 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2525 27.1542L12.495 32.9525L24.5 44.9167L45.6925 23.765L39.935 17.9667L24.5 33.4017M49 0H8.16667C3.675 0 0 3.675 0 8.16667V73.5L28.5833 61.25L57.1667 73.5V8.16667C57.1667 3.675 53.4917 0 49 0ZM49 61.25L28.5833 52.3483L8.16667 61.25V8.16667H49V61.25Z",
    fill: "#00ABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.7faae6cfeb1c137c3b224d5521f477fa.svg";
export { ForwardRef as ReactComponent };